module.exports = __webpack_public_path__ + "static/img/3.a192842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/3.png
// module id = JLOb
// module chunks = 0